import { render, staticRenderFns } from "./PhoneInputCountryItem.vue?vue&type=template&id=4a22f02d&scoped=true&"
import script from "./PhoneInputCountryItem.vue?vue&type=script&lang=ts&"
export * from "./PhoneInputCountryItem.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneInputCountryItem.vue?vue&type=style&index=0&id=4a22f02d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a22f02d",
  null
  
)

export default component.exports